import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '../../Icon';
import { Dropdown } from '../../Dropdown';
import { Spacing, Form } from '../../../theme';
import { useClickOutside } from '../../../hooks';
import { StyledPostTabContainer, StyledDropdownButton, } from './InputAddonsAfter.style';
import { useState, useRef } from 'react';
export function InputAddonsAfter({ dropdownOptions, onSelect, }) {
    const [isOpened, setIsOpened] = useState(false);
    const [dimensions, setDimensions] = useState({
        top: 0,
        left: 0,
        width: Form.SelectSize.XSmall,
    });
    const labelRef = useRef(null);
    const handleClickOutside = () => setIsOpened(false);
    const containerRef = useClickOutside(handleClickOutside);
    const toggleVisibility = (visible) => {
        const isVisible = visible !== null && visible !== void 0 ? visible : !isOpened;
        setIsOpened(visible !== null && visible !== void 0 ? visible : !isOpened);
        if (isVisible && labelRef.current) {
            const boundingClientRect = labelRef.current.getBoundingClientRect();
            setDimensions({
                top: boundingClientRect.top,
                left: boundingClientRect.left +
                    boundingClientRect.width +
                    Spacing.Size.XXSmall,
                width: Form.SelectSize.XSmall,
            });
        }
    };
    const handleSelect = (selectedValue) => {
        toggleVisibility(false);
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(selectedValue);
    };
    return (_jsxs(StyledPostTabContainer, { ref: containerRef, children: [_jsx(StyledDropdownButton, { ref: labelRef, onClick: () => toggleVisibility(), children: _jsx(Icon, { name: 'chevron---right' }) }), _jsx(Dropdown, { options: dropdownOptions, dimensions: dimensions, opened: isOpened, onSelect: handleSelect })] }));
}
//# sourceMappingURL=InputAddonsAfter.js.map